import type { IFramePostMessageDataLocationValue } from '../types';

export class IFrameUrlState {
  private readonly url: URL;

  constructor(origin: string, startingPathname: string) {
    this.url = new URL(startingPathname, origin);
  }

  setLocation(value: IFramePostMessageDataLocationValue): void {
    this.url.pathname = value.pathname;
    this.url.search = value.search;
  }

  isDifferentPathname(value: IFramePostMessageDataLocationValue): boolean {
    return this.url.pathname !== value.pathname;
  }

  get location() {
    return {
      pathname: this.url.pathname,
      search: this.url.search,
    };
  }

  get href(): string {
    return this.url.toString();
  }

  get relativePath(): string {
    return this.url.href.replace(this.url.origin, '');
  }
}
